import type { ReactNode, RefObject } from 'react'
import { AiChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'

type FloatingAssistantButtonProps = {
  isSmallScreen: boolean
  onClick: () => void
  buttonRef?: RefObject<HTMLButtonElement>
  trailingContent?: ReactNode
}

/** Anchored to the workspace; its parent must establish a positioning context. */
export default function FloatingAssistantButton({ isSmallScreen, onClick, buttonRef, trailingContent }: FloatingAssistantButtonProps) {
  if (isSmallScreen) {
    return (
      <IconButton
        ref={buttonRef}
        variant="filled"
        size="lg"
        icon={<AiChat />}
        aria-label="AI Assistant"
        onClick={onClick}
        className="absolute bottom-7 right-7 z-10"
      />
    )
  }

  return (
    <div className="absolute bottom-4 right-4 z-10 flex items-center">
      <Button ref={buttonRef} leadingIcon={<AiChat className="h-[18px] w-[18px]" />} onClick={onClick}>
        AI Assistant
      </Button>
      {trailingContent}
    </div>
  )
}
